import React from "react";

// WW-146.k · safari details, shown on the review desk only when the country is not Kenya.
const COSTS = [["fully_funded", "fully funded"], ["partly_funded", "partly funded"], ["self_funded", "self funded"]];
const COVERS = [["flights", "flights"], ["stay", "stay"], ["meals", "meals"], ["visa_letter", "visa letter"]];

export const SafariDetailsPanel = ({ value, onChange }) => {
  const s = value || {};
  const set = (k, v) => onChange({ ...s, [k]: v });
  const covers = s.covers || [];
  const toggle = (k) => set("covers", covers.includes(k) ? covers.filter((c) => c !== k) : [...covers, k]);
  return (
    <div data-testid="safari-details-panel" className="mt-3 rounded-md border border-neutral-300 p-3">
      <p className="label-tiny">safari details</p>
      <p className="mt-2 text-xs">cost to go</p>
      <div className="mt-1 flex flex-wrap gap-3 text-sm" role="radiogroup">
        {COSTS.map(([k, l]) => (
          <label key={k} className="inline-flex items-center gap-1">
            <input type="radio" name="safari-cost" data-testid={`safari-cost-${k}`} checked={s.cost === k} onChange={() => set("cost", k)} /> {l}
          </label>
        ))}
      </div>
      <p className="mt-3 text-xs">what is paid for</p>
      <div className="mt-1 flex flex-wrap gap-3 text-sm">
        {COVERS.map(([k, l]) => (
          <label key={k} className="inline-flex items-center gap-1">
            <input type="checkbox" data-testid={`safari-covers-${k}`} checked={covers.includes(k)} onChange={() => toggle(k)} /> {l}
          </label>
        ))}
      </div>
      <label className="mt-3 block text-xs">apply by
        <input type="date" data-testid="safari-apply-by" value={s.apply_by || ""} onChange={(e) => set("apply_by", e.target.value)}
               className="mt-1 block w-full rounded-md border border-neutral-300 p-2 text-sm" />
      </label>
      <label className="mt-3 block text-xs">who can apply
        <input data-testid="safari-who-can-apply" value={s.who_can_apply || ""} onChange={(e) => set("who_can_apply", e.target.value)}
               className="mt-1 block w-full rounded-md border border-neutral-300 p-2 text-sm" />
      </label>
    </div>
  );
};
